// Admin API client — /admin/content/* (mirrors the API's content aggregate).

import type {
  RenderedContent,
  PublishingQueueResponse,
  ContentFeedbackListResponse,
  ContentFeedbackStatusRequest,
  ContentFeedback,
  ContentSection,
} from '@a7y/types';
import { client } from './transport';
import { contentMutate, blogMutate } from './content-transport';

export const contentApi = {
  // ------------------------------------------------------------------------------------
  // Generic content admin (A7Y-4474/A7Y-4470): the shared render-preview
  // endpoint, the cross-section Publishing queue, and reader feedback.
  content: {
    render: (markdown: string, signal?: AbortSignal) =>
      blogMutate<RenderedContent>('/content/render', 'POST', { markdown }, signal),

    publishing: async (): Promise<PublishingQueueResponse> => {
      const res = await client.get<{ success: true; data: PublishingQueueResponse }>(
        '/content/publishing'
      );
      return res.data;
    },

    feedback: {
      list: (q?: { status?: string; section?: ContentSection }) => {
        const sp = new URLSearchParams();
        if (q?.status) sp.set('status', q.status);
        if (q?.section) sp.set('section', q.section);
        const qs = sp.toString();
        return client.get<ContentFeedbackListResponse>(`/content/feedback${qs ? `?${qs}` : ''}`);
      },
      setStatus: (id: string, status: ContentFeedbackStatusRequest['status']) =>
        contentMutate<ContentFeedback>(`/content/feedback/${id}`, 'PATCH', { status }),
    },
  },
};
